module.exports = __webpack_public_path__ + "img/1_2-commerciale-museo-2.b1ab1b44.png";